import { render, staticRenderFns } from "./CreateNewModal.vue?vue&type=template&id=23d7351a&scoped=true&lang=pug"
import script from "./CreateNewModal.vue?vue&type=script&lang=js"
export * from "./CreateNewModal.vue?vue&type=script&lang=js"
import style0 from "./CreateNewModal.vue?vue&type=style&index=0&id=23d7351a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d7351a",
  null
  
)

export default component.exports